export default __webpack_public_path__ + "static/media/slide19.6abd94ae.png";